import * as React from "react";

function SvgLeftarrow() {
    return (
        <svg id="Group_2" data-name="Group 2" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '-2px' }} fill='#284672 ' width="12.073" height="12.073" viewBox="0 0 15.073 15.073">
            <path id="Icon_ionic-md-arrow-dropleft" data-name="Icon ionic-md-arrow-dropleft" d="M21.036,9,13.5,16.536l7.536,7.536Z" transform="translate(-13.5 -9)" fill="#284672 " />
            <path id="Icon_ionic-md-arrow-dropleft-2" data-name="Icon ionic-md-arrow-dropleft" d="M21.036,9,13.5,16.536l7.536,7.536Z" transform="translate(-5.964 -9)" fill="#284672 " />
        </svg>
    )
}
export default SvgLeftarrow;


// WEBPACK FOOTER //
// ./src/iconComponents/taskLeftarrow.js